export * from "./tokens";
export * from "./tokensTestnet";

import { Address, Chain } from "viem";
import { arbitrum, sepolia } from "viem/chains";

import * as TOKENS from "./tokens";
import * as TOKENS_TESTNET from "./tokensTestnet";

export interface ERC20Metadata {
  chainId: Chain["id"];
  name: string;
  symbol: string;
  logo: string;
  address: Address;
  decimals: number;
  OftAdapter: Address;
  peerToken: ERC20Metadata;
  mainToken: ERC20Metadata;
}

type TokenPair = { main: ERC20Metadata; peer: ERC20Metadata };

type AppTokens = { usdai: TokenPair; pyusd: TokenPair };

export const ALL_TOKENS: ERC20Metadata[] = [
  ...TOKENS.MAINNET_ALL_TOKENS,
  ...TOKENS_TESTNET.TESTNET_ALL_TOKENS,
];

export const TOKENS_ADAPTERS: Record<Address, Address> = {
  ...TOKENS.MAINNET_TOKENS_ADAPTERS,
  ...TOKENS_TESTNET.TESTNET_TOKENS_ADAPTERS,
};

export const TOKENS_PEER: Record<Address, Address> = {
  ...TOKENS.MAINNET_TOKENS_PEER,
  ...TOKENS_TESTNET.TESTNET_TOKENS_PEER,
};

export const APP_TOKENS: { [loanChainId: number]: AppTokens } = {
  [arbitrum.id]: {
    usdai: {
      main: TOKENS.USDAI_TOKEN_ARB,
      peer: TOKENS.USDAI_TOKEN_ETH,
    },
    pyusd: {
      main: TOKENS.PYUSD_TOKEN_ARB,
      peer: TOKENS.PYUSD_TOKEN_ETH,
    },
  },
  [sepolia.id]: {
    usdai: {
      main: TOKENS_TESTNET.USDAI_TOKEN_SEP,
      peer: TOKENS_TESTNET.USDAI_TOKEN_ARBSEP,
    },
    pyusd: {
      main: TOKENS_TESTNET.PYUSD_TOKEN_SEP,
      peer: TOKENS_TESTNET.PYUSD_TOKEN_ARBSEP,
    },
  },
};
